

import React, { useState, useEffect } from "react";
import { postData } from "../../components/helpers/Data";
import Modal2 from "../../components/helpers/Modal2";
import { userAccessDetails } from "../../components/helpers/UserAccessDetails";
import { userSaveDetails } from "../../components/helpers/UserSaveDetails";

export const NewPassword = () => {
  //save access log
  useEffect(() => {
    userAccessDetails(113);
  }, []);

  //create array for logs when renewing corp
  const logData = userSaveDetails(113);

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [feedback, setFeedback] = useState([]);

  const validateInput = (e) => {
    e.preventDefault();
    const formData = new FormData(document.getElementById("login_form"));
    //append access log details
    formData.append("user_id", logData[0]);
    formData.append("accessed_item", logData[1]);
    formData.append("browser_type", logData[2]);
    formData.append("os_type", logData[3]);

    let strongRegex = new RegExp(
      "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})"
    );

    const new_password = document.getElementById("new_password").value;
    const confirm_password = document.getElementById("confirm_password").value;
    const old_password = document.getElementById("old_password").value;
    let result = strongRegex.test(new_password);
    if (result) {
      if (new_password === confirm_password) {
        if (new_password !== old_password) {
          changeUserPassword(formData);
        } else {
          setFeedback(["New password cannot be the same as current password!"]);
          setModalIsOpen(true);
        }
      } else {
        setFeedback(["New Password and confirm password must match!"]);
        setModalIsOpen(true);
      }
    } else {
      setFeedback([
        "PASSWORD MUST MEET THE FOLLOWING REQUIREMENTS:",
        "1. A minimum of 8 characters",
        "2. At least one uppercase letter",
        "3. At least one lowercase letter",
        "4. At least one number",
        "5. At least one special character such as #, @, and $",
      ]);
      setModalIsOpen(true);
    }
  };

  const changeUserPassword = (formData) => {
    postData(formData, "update_user_password")
      .then((data) => {
        if (data[0].includes("Error")) {
          console.log(data);
          setFeedback(["Error updating password!"]);
        } else {
          setFeedback(data);
        }
        setModalIsOpen(true);
      })
      .catch((error) => {
        console.log(error);
        setFeedback(["Error updating password!"]);
        setModalIsOpen(true);
      });
  };

  const closeModal = () => {
    setModalIsOpen(false);
    if (feedback[0].includes("Password updated successfully")) {
      window.location.reload();
    }
  };

  return (
    <div>
      <div className="login_wrapper">
        <span className="text-danger text-center col-md-12">
          Create New Password
        </span>
        <div className="animate form login_form">
          <section className="login_content">
            <form id="login_form" onSubmit={validateInput}>
              <div>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Username"
                  required={true}
                  name="username"
                />
              </div>
              <div>
                <input
                  type="password"
                  className="form-control"
                  placeholder="Current password"
                  required={true}
                  name="old_password"
                  id="old_password"
                />

                <p style={{ color: "red" }}></p>
              </div>
              <div>
                <input
                  type="password"
                  className="form-control"
                  placeholder="New password"
                  required={true}
                  name="new_password"
                  id="new_password"
                />

                <p style={{ color: "red" }}></p>
              </div>
              <div>
                <input
                  type="password"
                  className="form-control"
                  placeholder="Confirm new password"
                  required={true}
                  name="confirm_password"
                  id="confirm_password"
                />

                <p style={{ color: "red" }}></p>
              </div>
              <div>
                <button type="submit" className="btn btn-info form-control">
                  Update
                </button>
              </div>
            </form>
          </section>
        </div>
      </div>
      <Modal2
        modalIsOpen={modalIsOpen}
        closeModal={closeModal}
        body={
          <span className="h4 text-white font-weight-bold text-center">
            {feedback.map((fb) => {
              return (
                <p className="h4 text-white font-weight-bold text-left">{fb}</p>
              );
            })}
          </span>
        }
        background={
          feedback.length > 0
            ? feedback[0].includes("Sorry")
              ? "#d9534f"
              : "#105878"
            : ""
        }
      />
    </div>
  );
};

export default NewPassword;
